// extracted by mini-css-extract-plugin
export default {"Container":"AllBranches_Container__AubUT","Title":"AllBranches_Title__syxdf","SubTitle":"AllBranches_SubTitle__-A3oD"};